import BaseDataProvider from "./BaseDataProvider";
import { gql } from "apollo-boost";

class TeamsDataProvider extends BaseDataProvider {
  async getOne(resource, params) {
    console.log(
      "TeamsDataProvider.getOne(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const GET = gql`
          query {
            TeamByID(id:"${params.id}") {
              id
              sportCode
              name
              teamCode
              school {
                id
                logoUrl
              }
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      //console.log(JSON.stringify(response, null, 2));
      return { data: response.data.TeamByID };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async create(resource, params) {
    console.log(
      "TeamsDataProvider.create(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const objectInfo = JSON.parse(JSON.stringify(params.data));
    objectInfo.school = objectInfo.school_id;
    delete objectInfo.school_id;
    var objectString = JSON.stringify(objectInfo).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    objectString = objectString.substring(1, objectString.length - 1).trim();
    const CREATE_OBJECT = gql`
          mutation {
            CreateTeam(${objectString}) {
              id
              sportCode
              name
              teamCode
              school {
                id
                logoUrl
              }
            }
          }`;
    const response = await this.client.mutate({ mutation: CREATE_OBJECT });
    return { data: response.data.CreateTeam };
  }

  async update(resource, params) {
    console.log(
      "TeamsDataProvider.update(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const objectInfo = JSON.parse(JSON.stringify(params.data));
    delete objectInfo.__typename;
    delete objectInfo.sportCode;
    delete objectInfo.school;
    var objectString = JSON.stringify(objectInfo).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    objectString = objectString.substring(1, objectString.length - 1).trim();
    const MUTATION = gql`
          mutation {
            UpdateTeam(${objectString}) {
              id
              sportCode
              name
              teamCode
              school {
                id
                logoUrl
              }
            }
          }`;
    try {
      const response = await this.client.mutate({ mutation: MUTATION });
      //console.log(JSON.stringify(response, null, 2));
      return { data: response.data.UpdateTeam };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async delete(resource, params) {
    let infoString = JSON.stringify({ id: params.id }).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    infoString = infoString.substring(1, infoString.length - 1).trim();
    const DESTROY_OBJECT = gql`
            mutation {
              DeleteTeamByID(${infoString})
            }`;
    try {
      // eslint-disable-next-line no-unused-vars
      const response = await this.client.mutate({ mutation: DESTROY_OBJECT });
      return { data: params.previousData };
    } catch (err) {
      if (
        err.message &&
        err.message.includes("violates foreign key constraint") &&
        err.message.includes("school_sport_team_seasons")
      )
        err.message =
          "Cannot delete a team when the team has associated seasons.";
      throw err;
    }
  }

  async getManyReference(resource, params) {
    console.log(
      "TeamsDataProvider.getManyReferences(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const GET = gql`
          query {
            SchoolByID(id:"${params.id}") {
              id
              stableId
              name
              logoUrl
              teams {
                id
                sportCode
                name
                teamCode
              }
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      const data = response.data.SchoolByID.teams;
      return { data: data };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }
}

export default TeamsDataProvider;
